const { DateRange, extendMoment } = require('moment-range');

module.exports.DateRange = DateRange;
module.exports.extendMoment = extendMoment;
